import React from 'react';
import classNames from 'classnames';
import { CheckIcon } from '@heroicons/react/24/outline';
import { ColumnSelectOption } from './ColumnSelect';

interface ColumnSelectItemProps<T extends string> {
  option: ColumnSelectOption<T>;
  active: boolean;
  selected: boolean;
}

/**
 * A simple text-only select item.
 */
export function ColumnSelectItem<T extends string>({
  option,
  active,
  selected
}: ColumnSelectItemProps<T>) {
  return (
    <div
      id={`${option.value}-option-label`}
      className={classNames(
        {
          'bg-blue-50 text-blue-500': active
        },
        'cursor-pointer rounded p-3 hover:bg-blue-50 hover:text-blue-500 focus:outline-none transition ease-in duration-100'
      )}
    >
      <span className="flex justify-between">
        {option.label}
        {selected && <CheckIcon className="w-4 h-4" />}
      </span>
      {option.description && (
        <span className="opacity-75"> - {option.description}</span>
      )}
    </div>
  );
}
